module.exports = __webpack_public_path__ + "static/media/DKGdLittoral.7db7c027.png";